<template>
  <div class="administrasi-section">
    <v-container grid-list-xs class="d-flex justify-center align-center">
      <div class="card-wrapper">
        <v-card class="pa-5">
          <div class="card-title d-flex justify-center align-center my-5 text-center">
            <h3>Biaya Daftar Ulang Bagi Calon Siswa yang Diterima</h3>
          </div>
          <div class="content">
            <v-simple-table>
              <thead>
                <th>Kompetensi Keahlian</th>
                <th>Uraian Pembayaran Siswa</th>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div class="py-2">1. Produksi Grafika</div>
                    <div class="py-2">2. Desain Grafika</div>
                  </td>
                  <td>
                    <v-row v-for="info in uraianPemabayaran.first" :key="info.text" class="my-3">
                      <v-col cols="12" sm="6" md="6" lg="6" class="py-1">{{ info.text }}</v-col>
                      <v-col class="py-1">Rp {{ info.value }},00</v-col>
                    </v-row>
                    <v-row class="my-3">
                      <v-col cols="12" sm="6" md="6" lg="6" class="py-1">
                        <h4>Total Pembayaran</h4>
                      </v-col>
                      <v-col class="py-1">
                        <h4>Rp 3.400.000,00</h4>
                      </v-col>
                    </v-row>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="py-2">3. Animasi</div>
                    <div class="py-2">4. Desain Komunikasi Visual</div>
                    <div class="py-2">5. Rekayasa Perangkat Lunak</div>
                  </td>
                  <td>
                    <div class="dalam-kota py-3 mt-5">
                      <div>
                        <span class="font-weight-bold">Dalam Kota</span> (Calon siswa yang berasal dari dalam kabupaten Kudus)
                      </div>
                      <v-row
                        v-for="info in uraianPemabayaran.second.dalamKota"
                        :key="info.text"
                        class="my-3"
                      >
                        <v-col cols="12" sm="6" md="6" lg="6" class="py-1">{{ info.text }}</v-col>
                        <v-col class="py-1">Rp {{ info.value }},00</v-col>
                      </v-row>
                      <v-row class="my-3">
                        <v-col cols="12" sm="6" md="6" lg="6" class="py-1">
                          <h4>Total Pembayaran</h4>
                        </v-col>
                        <v-col class="py-1">
                          <h4>Rp 5.000.000,00</h4>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="luar-kota py-3">
                      <div>
                        <span class="font-weight-bold">Luar Kota</span> (Calon siswa yang berasal dari luar kabupaten Kudus)
                      </div>
                      <v-row
                        v-for="info in uraianPemabayaran.second.luarKota"
                        :key="info.text"
                        class="my-3"
                      >
                        <v-col cols="12" sm="6" md="6" lg="6" class="py-1">{{ info.text }}</v-col>
                        <v-col class="py-1">Rp {{ info.value }},00</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="6" lg="6" class="py-1">
                          <h4>Total Pembayaran</h4>
                        </v-col>
                        <v-col class="py-1">
                          <h4>Rp 14.000.000,00</h4>
                        </v-col>
                      </v-row>
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <p class="pt-3 mb-0">Keterangan</p>
            <ul>
              <li>Biaya daftar ulang sudah termasuk kain seragam 5 stel, MOPDIK, Buku LKS semester gasal.</li>
              <li>
                Keterangan tempat tinggal atau domisili dibuktikan dengan
                <b>Kartu Keluarga (KK)</b> yang diterbitkan sebelum
                <b>Januari 2019</b>.
              </li>
            </ul>
          </div>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    uraianPemabayaran: {
      first: [
        { text: "SPP Juli 2020", value: "200.000" },
        { text: "Gedung / SPI", value: "2.000.000" },
        { text: "Keperluan Siswa", value: "1.200.000" }
      ],
      second: {
        dalamKota: [
          { text: "SPP Juli 2020", value: "300.000" },
          { text: "Gedung / SPI", value: "3.500.000" },
          { text: "Keperluan Siswa", value: "1.200.000" }
        ],
        luarKota: [
          { text: "SPP Juli 2020", value: "800.000" },
          { text: "Gedung / SPI", value: "12.000.000" },
          { text: "Keperluan Siswa", value: "1.200.000" }
        ]
      }
    }
  })
};
</script>

<style scoped>
.administrasi-section {
  min-height: 80vh;
}

.card-wrapper {
  width: 80%;
  margin: 100px 0;
}

@media screen and (max-width: 900px) {
  .card-wrapper {
    width: 100%;
  }
}
</style>